module.exports = __webpack_public_path__ + "img/2-5.54daf2fc.png";